<ng-container
	*ngIf="action === 'addResource'|| action === 'addScorm' || action === 'editScorm' || action === 'editResource' || action === 'reject'|| action === 'editBeadResource'">
	<app-form-view [popup]="formPopup" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-resource-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<loader [loader]="documentLoader" [type]="'general'"
						[data]="{'msg': locale.translate('processing_pdf_document_please_wait')}"></loader>
						<!-- your-component.component.html -->
						<!-- <div role="progressbar" [style.width.%]="progress.message" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
							{{uploadResponse.message}}%
						  </div> -->
						<ng-container *ngIf="showUploadProgress">
							<app-progressbar [fileCompleted]='fileCompleted' [valueInBytes]="progress" [totalValueInBytes]="100" [uploadFailed]="uploadFailed" (resume)="createScorm()" (closed)="closePopup()" (close)="cancelPopup()"></app-progressbar>
						</ng-container>
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="30px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
									<!---replace-->
									<ng-container
										*ngIf="['editResource', 'editBeadResource'].includes(action) && showThumbnail && ['audio', 'video', 'link', 'document'].includes(resourceDetail?.resourceFormat?.key)">
										<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxLayout.xs="column"
											fxLayoutGap.xs="0px">
											<ng-container *ngIf="!([null, undefined, ''].includes(resourceDetail?.resource?.thumbnail))">
												<div fxFlex="0 0 150px" fxFlex.xs="100%">
													<div class="thumbnail-block">
														<img [src]="resourceDetail?.resource?.thumbnail"
															(error)="gfService.setErrorImage($event, 'broken_image')">
													</div>
												</div>
											</ng-container>
											<div fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="5px">
												<ng-container
													*ngIf="resourceDetail?.resourceFormat?.key === 'link' && resourceDetail?.resource?.link">
													<div class="sub-caption-2 linkable">
														<p>{{resourceDetail?.resource?.link}}</p>
													</div>
												</ng-container>
												<div class="replace-link">
													<p class="hyperlink" (click)="alertPopup('removeThumbnail', null, {})">
														{{locale.translate('replace')}}</p>
												</div>
											</div>
										</div>
									</ng-container>
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
											fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch" (formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<ng-container *ngIf="resourceFields.length > 0">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<div class="block-title"> {{ locale.translate('resource_info') }} </div>
											<div fxLayout fxLayoutAlign="center start" class="form-container">
												<app-form-group [fieldList]="resourceFields" [formObjectData]="formObjectData" [config]="config"
													fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
													fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
													(formObject)="resourceObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</ng-container>
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="keywordsField?.length">
											<div class="block-title"> {{ locale.translate('keywords') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group [fieldList]="keywordsField" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="keywordsFormReader($event)">
											</app-form-group>
										</div>
									</div>
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<ng-container *ngIf="skillField?.length">
											<div class="block-title"> {{ locale.translate('skills') }} </div>
										</ng-container>
										<div fxLayout fxLayoutAlign="center start" class="form-container">
											<app-form-group class="checkbox-lbl" [fieldList]="skillField" [config]="config" fxLayout="column"
												fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="skillFormReader($event)">
											</app-form-group>
										</div>
									</div>

									<div class="collapsible-area-container" fxLayout="column" fxLayoutAlign="start stretch"
										fxLayoutGap="20px">
										<ng-container *ngIf="action === 'addResource' || action === 'editResource'">
											<app-collapsible-area [data]="{title: locale.translate('linked_resources')}"
												[toggle]="{expanded: false, showToggle: true}" color="#fff">
												<div class="linked-resource-content-area" fxLayout="column" fxLayoutAlign="start stretch"
													fxLayoutGap="17px">
													<ng-container
														*ngFor="let resource of selectedResources; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let resourceIndex = index">

														<div class="updates-content fx-column fx-start-stretch">

															<div class="card-block fx-column fx-start-stretch">
																<ng-container
																	*ngIf="!['playlist', 'answer','internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
																	<app-content-image-card [record]="resource" [type]="'minimal'"
																		(remove)="removeResource(resourceIndex)">
																	</app-content-image-card>
																</ng-container>
																<ng-container *ngIf="resource?.resourceType?.key === 'playlist'">
																	<app-playlist-card [data]="resource" [type]="'minimal'"
																		(remove)="removeResource(resourceIndex)">
																	</app-playlist-card>
																</ng-container>
																<ng-container *ngIf="resource?.resourceType?.key === 'answer'">
																	<app-question-card [type]="'minimal'" [data]="resource"
																		(remove)="removeResource(resourceIndex)">
																	</app-question-card>
																</ng-container>
																<ng-container
																	*ngIf="['internalEvent', 'externalEvent'].includes(resource?.resourceType?.key)">
																	<app-event-card [type]="'minimal'" [data]="resource"
																		(remove)="removeResource(resourceIndex)">
																	</app-event-card>
																</ng-container>
															</div>
														</div>

														<!-- <app-content-image-card [type]="'minimal'" [record]="resource"
															(remove)="removeResource(resourceIndex)"></app-content-image-card> -->
														<!-- <div class="resource-search-card" fxLayout="row" fxLayoutAlign="start stretch">

															<ng-container *ngIf="![null, undefined, ''].includes(resource.thumbnail)">
																<div fxFlex="0 0 90px" class="resource-thumbnail">
																	<div class="thumbnail">
																		<img [src]="resource.thumbnail"
																			(error)="gfService.setErrorImage($event, 'broken_image')">
																		<ng-container *ngIf="resource?.format">
																			<div class="img-overlay" fxLayout="row" fxLayoutAlign="center center">
																				<div class="format-icon" fxLayout="row" fxLayoutAlign="center center">
																					<ng-container *ngIf="resource?.format === 'video'">
																						<mat-icon svgIcon="video_camera">
																						</mat-icon>
																					</ng-container>
																					<ng-container *ngIf="resource?.format === 'audio'">
																						<mat-icon svgIcon="audio_headphone">
																						</mat-icon>
																					</ng-container>
																					<ng-container *ngIf="resource?.format === 'page'">
																						<mat-icon svgIcon="pages">
																						</mat-icon>
																					</ng-container>
																					<ng-container *ngIf="resource?.format === 'link'">
																						<mat-icon svgIcon="external_link">
																						</mat-icon>
																					</ng-container>
																					<ng-container *ngIf="resource?.format === 'document'">
																						<mat-icon svgIcon="document">
																						</mat-icon>
																					</ng-container>
																					<ng-container *ngIf="resource?.format === 'image'">
																						<mat-icon svgIcon="image_collection"></mat-icon>
																					</ng-container>
																				</div>
																			</div>
																		</ng-container>
																	</div>
																</div>
															</ng-container>
															<div class="search-card-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
																fxLayoutAlign="start stretch" fxLayoutGap="4px">
																<div fxLayout="row" fxLayoutAlign="start start">
																	<div class="sub-txt-patch">
																		{{resource.type}}</div>
																</div>
																<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
																	<p class="card-title" fxFlex="1 1" fxFlex.xs="auto">
																		{{resource.title}}</p>
																</div>
															</div>

															<div class="resource-item-btn">
																<button mat-icon-button (click)="removeResource(resourceIndex)">
																	<mat-icon>close
																	</mat-icon>
																</button>
															</div>
														</div> -->
													</ng-container>

													<div fxLayout fxLayoutAlign="center start" class="form-container">
														<app-form-group [fieldList]="linkedResourceField" [formObjectData]="formObjectData"
															[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
															fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
															(formObject)="formObjectReader($event)">
														</app-form-group>
													</div>

												</div>
											</app-collapsible-area>
										</ng-container>
										<ng-container *ngIf="this.action === 'addResource'">
											<app-collapsible-area [data]="{title: locale.translate('publish')}"
												[toggle]="{expanded: true, showToggle: true}" color="#fff">
												<div class="visibility-content-area" fxLayout="column" fxLayoutAlign="start stretch"
													fxLayoutGap="10px">
													<span class="visibility-desc">
														{{locale.translate('select_channels_to_publish_if_not_published_desc')}}
													</span>
													<div fxLayout fxLayoutAlign="center start" class="form-container">
														<app-form-group [fieldList]="visibilityField" [formObjectData]="formObjectData"
															[config]="config" fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
															fxLayoutAlign.xs="start stretch" fxLayoutGap="0px" fxLayoutGap.xs="0px"
															(formObject)="formObjectReader($event)">
														</app-form-group>
													</div>

												</div>
											</app-collapsible-area>
										</ng-container>
									</div>
									<app-alert id="addResourceAlert"></app-alert>

								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'addResource' || action === 'addScorm' ">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('submit')}}</button>
										</ng-container>
										<ng-container *ngIf="action === 'editResource' || action === 'editBeadResource' || action === 'editScorm' ">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('update')}}</button>
										</ng-container>

										<ng-container *ngIf="action === 'reject'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('reject')}}</button>
										</ng-container>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
										<ng-container *ngIf="action === 'reject'">
											<!-- <button (click)="guideline()" mat-button class="cancel-btn"
												type="button">{{locale.translate('guidelines')}}</button> -->
											<p class="hyperlink" (click)="guideline()">{{locale.translate('guidelines')}}</p>
										</ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'resourceFormat'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="resource-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row wrap" fxLayoutAlign="center center">
					<ng-container
						*ngFor="let resourceFormatData of resourceFormatList; trackBy: gfService.trackByID.bind({'key': 'resourceFormat'})">
						<div class="resource-controls" fxLayout="column" fxLayoutAlign="start stretch"
							(click)="submit(resourceFormatData)">
							<div class="control-item cursor-pointer" fxLayout="column" fxLayoutAlign="center center"
								fxLayoutGap="10px">
								<mat-icon [svgIcon]="resourceFormatData.svgIcon">{{resourceFormatData.icon}}</mat-icon>
								<span class="caption">{{resourceFormatData.caption}}</span>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'guideline'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="resource-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div class="guideline-block" fxLayout="row wrap" fxLayoutAlign="center center">
					<ng-container *ngIf="![null,undefined].includes(info)">
						<div class="guideline-content" [innerHtml]="info | safeDom"></div>
					</ng-container>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="action === 'forwardResource'">
	<app-form-view [popup]="formPopup" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="forward-resource" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<div class="form-info">
							<p class="body-text">
								{{locale.translate('forward_resource_desc')}}
							</p>
						</div>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="forwardFormObject($event)"></app-form-group>
									</div>
									<app-alert id="forwardResourceAlert"></app-alert>

								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<ng-container *ngIf="action === 'forwardResource'">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('forward')}}</button>
										</ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'settings'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="resource-settings" fxLayout="row" fxLayoutAlign="center center">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch" fxFlex="95" fxFlex.xs="100%">
					<div fxLayout="column" fxLayoutAlign="start stretch">
						<mat-tab-group class="custom-tab"
							[ngClass]="{'responsive-tab': detectDevice?.resolutionState$?.value?.deviceType === 'mobile'}"
							mat-align-tabs="center" [selectedIndex]="tabIndex" (selectedIndexChange)="tabChange($event, true)" #tab>
							<mat-tab [label]="locale.translate('general')">
								<ng-container *ngIf="tabIndex === 0">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<div fxLayout="row" fxLayoutAlign="center start" class="form-container">
											<div fxFlex="80%" fxFlex.xs="100%">
												<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
													fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</div>
									<app-alert id="addResourceAlert"></app-alert>
									<div fxLayout="column" fxLayoutAlign="start stretch">
										<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('save')}}</button>

											<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
												class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
										</div>
									</div>
								</ng-container>
							</mat-tab>
							<mat-tab [label]="locale.translate('channels')">
								<ng-container *ngIf="tabIndex === 1">
									<div class="completed-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<div fxLayout="row" fxLayoutAlign="center start" class="form-container">
											<div fxFlex="80%" fxFlex.xs="100%">
												<ng-container *ngIf="formFields?.length">
													<div class="body-text"> {{
														locale.translate('select_channels_to_publish_if_not_published_desc') }}
													</div>
												</ng-container>

												<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
													fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
												</app-form-group>
											</div>
										</div>
									</div>
									<app-alert id="addResourceAlert"></app-alert>
									<div fxLayout="column" fxLayoutAlign="start stretch">
										<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
											<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
												type="button">{{locale.translate('save')}}</button>

											<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button
												class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
										</div>
									</div>
								</ng-container>
							</mat-tab>

							<mat-tab [label]="locale.translate('info')">
								<ng-container *ngIf="tabIndex === 2">
									<div class="completed-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<div fxLayout="row" fxLayoutAlign="center start" class="form-container">
											<div fxFlex="80%" fxFlex.xs="100%">
												<div class="body-text" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
													<div fxLayout="column" fxLayoutAlign="start stretch">
														<span>{{locale.translate('created_by')}}</span>
														<app-chips type="prime" (title)="searchPeopleDetail(resourceDetail?.createdUser?.ID)"
															[data]="{title: resourceDetail?.createdUser?.name, imageSrc: resourceDetail?.createdUser?.profilePicURL}">
														</app-chips>
													</div>
													<ng-container *ngIf="infoTabData?.length">
														<ng-container *ngFor="let info of infoTabData">
															<app-common-view [data]="info"></app-common-view>
														</ng-container>
													</ng-container>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>

</ng-container>

<ng-container *ngIf="action === 'viewImage'">
	<div class="resource-image-view" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
		<ng-container *ngIf="imageList?.length">
			<app-slider [slides]="imageList" [options]="mainSlider">
				<ng-template #template let-slides>
					<div class="slider-block">
						<div class="img-container">
							<div class="thumbnail-block">
								<img class="slider-img" [src]="![null, undefined, ''].includes(slides?.file) ? slides?.file :
												'assets/img/resource-default-image.jpg'" (error)="gfService.setErrorImage($event, 'broken_image')"
									[ngClass]="{'xs' : detectDevice?.resolutionState$?.value?.xs}">
							</div>
						</div>
						<ng-container *ngIf=slides?.caption>
							<p class="slider-caption" fxLayoutAlign="start start">{{slides?.caption}}</p>
						</ng-container>
					</div>

				</ng-template>

			</app-slider>

			<!-- <div fxLayout="column" fxLayoutAlign="start stretch">
						<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
							<button (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
								type="button">{{locale.translate('close')}}</button>
						</div>
					</div> -->

		</ng-container>
	</div>
</ng-container>

<ng-container *ngIf="action === 'editImageResource'">
	<app-form-view [popup]="formPopup" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="add-resource-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<!-- <loader [loader]="documentLoader" [type]="'general'"
						[data]="{'msg': locale.translate('processing_pdf_document_please_wait')}"></loader> -->
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [formObjectData]="formObjectData" [config]="config"
											fxLayout="column" fxLayoutAlign="start stretch" fxLayout.xs="column"
											fxLayoutAlign.xs="start stretch" (formObject)="formObjectReader($event)"></app-form-group>
									</div>

									<app-alert id="editImageResourceAlert"></app-alert>

								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">{{locale.translate('update')}}</button>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'makePublic'">
	<app-form-view [popup]="formPopup" [contentLoader]="loader" (helpTriggered)="helpTriggered = $event">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="forward-resource" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div class="content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
									<div fxLayout fxLayoutAlign="center start" class="form-container">
										<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
											fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
											(formObject)="makePublicFormObjectReader($event)"></app-form-group>
									</div>
									<app-alert id="addResourceAlert"></app-alert>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="submit()" mat-stroked-button class="submit-btn"
											type="button">
											{{locale.translate('submit')}}
										</button>

										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">
											{{locale.translate('cancel')}}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
		<insights>
			<app-help></app-help>
		</insights>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'resourceFilter'">
	<app-content-view [contentLoader]="loader">
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="resource-filter" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
					<div class="filter-list">
						<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="7px">
							<ng-container *ngFor="let filterData of record?.options; let i = index;">
								<div class="filter-list-item" fxLayout="row" fxLayoutAlign="space-between start" fxLayout="8px">
									<div class="filter-list-title linkable" (click)="popupRef.close(filterData)"
										[ngClass]="{'active': (filterData?.key === record?.selected?.value)}">
										{{ filterData?.value }}
									</div>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>
